import { Injectable } from '@angular/core';
import type { IListingFilterEvent, IListingSetFinalModelsEvent, Listing } from '@df/catalog-ui/listing/listing';
import { IsBannerPluginService } from '@df/catalog-ui/listing/plugin/banner/is-banner-plugin.service';
import type { IProductDataV2, Product } from '@df/catalog/product/product';
import { IN_STOCK_FILTER_ID } from './filter/stock/filter-stock';

@Injectable({
    providedIn: 'root'
})
export class IsBannerPluginServiceDecorator extends IsBannerPluginService {
    /**
     * If any filter is applied check
     */
    isFiltered(listing: Listing<Product<IProductDataV2>>): boolean {
        return !!listing.filters.find(filter => filter.hasSelection && filter.id !== IN_STOCK_FILTER_ID);
    }

    protected override onListingSetFinalModels(event: IListingSetFinalModelsEvent<Product<IProductDataV2>>): void {
        if (event.listing?.type === 'product') {
            // if filters or sorting are applied
            if (this.isFiltered(event.listing) || this.isSorted(event.listing)) {
                event.models = this.purify(event.models);
            }
        }
    }

    protected override onListingSetFilters(event: IListingFilterEvent<Product<IProductDataV2>>): void {
        if (event.listing.type === 'product') {
            // if filters are applied
            if (
                this.isFiltered(event.listing) &&
                event.listing.filters.find(filter => {
                    const selectionOverride = event.overrides?.find(i => i.filter === filter)?.selection;
                    // if override is false then skip filter completely
                    return selectionOverride !== false && (selectionOverride || filter.hasSelection);
                })
            ) {
                event.models = this.purify(event.models);
            }
        }
    }
}
